<template>
    <OverlayLoader :isLoading="!isLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="`${this.$translate.text('general.languages')} ( ${connection.name} )`"
                />

                <ConnectionMenu></ConnectionMenu>

                <div v-if="connection.webshop_type === 'woocommerce'">
                    <Alert>{{ t('alert.combine.languages.woocommerce') }}</Alert>
                </div>

                <WhiteTable v-else :labels="[$translate.text('clients.connections.language.shopname'), $translate.text('general.name'), $translate.text('clients.connections.language.code'), $translate.text('general.description')]">
                    <template slot="table-data">
                        <tr v-for="language in languages" :key="language.id">
                            <td >{{ language.language }}</td>
                            <td >{{ language.name }}</td>
                            <td >{{ language.code }}</td>
                            <td >{{ language.description }}</td>
                            <td class="align-right">
                                <i class="fal fa-edit" @click="$router.push({ name: 'Clients Connections Languages Edit', params: { id: $route.params.id, languageId: language.id } })" v-tooltip.bottom="$translate.text('tooltip.edit')"></i>
                                <i class="fal fa-trash-alt" @click="deleteLanguage(language.id)" v-tooltip.bottom="$translate.text('tooltip.delete')"></i>
                            </td>
                        </tr>
                        <tr v-if="!languages.length">
                            <td colspan="6">{{ t('general.no_results_found') }}</td>
                        </tr>
                    </template>
                </WhiteTable>
            </div>

            <FloatingButton
                @clicked="$router.push({ name: 'Clients Connections Languages Add' })"
            />
        </main>
    </OverlayLoader>
</template>
<script>
import swal from 'sweetalert';
import handleError from '@/helpers/error';
import Alert from '@/components/Alert/Alert';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import FloatingButton from '@/components/FloatingButton/FloatingButton';
import ConnectionMenu from '@/components/ConnectionMenu/ConnectionMenu';

export default {
    name: 'Languages',

    components: {
        Alert,
        ConnectionMenu,
        PageHeader,
        OverlayLoader,
        WhiteTable,
        FloatingButton,
    },

    data() {
        return {
            languages: [],
            connection: {},
            loaded: {
                items: {
                    languages: false,
                    connection: false,
                },
            },
        };
    },

    created() {
        this.getLanguages();
        this.getConnection();
    },

    methods: {
        getLanguages() {
            const id = this.$route.params.id;
            this.API.clients.connections.languagesIndex(id)
                .then((response) => {
                    this.languages = response.data.data;
                    this.loaded.items.languages = true;
                })
                .catch((error) => {
                    console.log(error);
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },
        getConnection() {
            this.API.clients.connections.show(this.$route.params.id)
                .then(response => {
                    this.connection = response.data.data;
                    this.loaded.items.connection = true;
                }).catch(error => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },
        deleteLanguage(id) {
            swal(
                this.$translate.text('alert.confirm.delete'),
                {
                    buttons: {
                        cancel: this.$translate.text('general.no'),
                        confirm: this.$translate.text('general.yes'),
                    },
                },
            ).then((value) => {
                if (value) {
                    this.API.clients.connections.languages.destroy(this.$route.params.id, id)
                        .then(() => {
                            this.getLanguages();
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                }
            });
        },
    },
    computed: {
        isLoaded() {
            return this.loaded.items.languages && this.loaded.items.connection;
        },
    },
};
</script>

<style scoped>
    .white-table {
        padding-top: 20px;
    }
</style>
